import { render, staticRenderFns } from "./AnswerSettingSection.vue?vue&type=template&id=50d294eb&"
import script from "./AnswerSettingSection.vue?vue&type=script&lang=js&"
export * from "./AnswerSettingSection.vue?vue&type=script&lang=js&"
import style0 from "./AnswerSettingSection.vue?vue&type=style&index=0&id=50d294eb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports